.accordion {
  overflow: hidden;
  position: relative;
}

.accordion__title {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.accordion__title:hover {
  cursor: pointer;
  text-decoration: underline;
}

.accordion__title:focus-visible {
  text-decoration: underline;
}

.accordion__title-icon,
.accordion__title-icon-right {
  transform: rotate(-90deg);
  transition: transform 300ms ease-in;
  margin-right: 0.25rem;
}

.accordion__title-icon--margin-0 {
  margin: 0;
}

.accordion__title-icon--margin-025 {
  margin: 0 0.25rem;
}

.accordion__title-icon--margin-050 {
  margin: 0 0.5rem;
}

.accordion__title-icon--margin-075 {
  margin: 0 0.75rem;
}

.accordion__title-icon--margin-100 {
  margin: 0 1rem;
}

.accordion__title-icon--margin-150 {
  margin: 0 1.5rem;
}

.accordion__title-icon--margin-200 {
  margin: 0 2rem;
}

.accordion__title-icon-right {
  margin-left: auto;
}

.accordion__title-icon--expanded,
.accordion__title-icon-right--expanded {
  transform: rotate(90deg);
  transition: transform 300ms ease-out;
}

.accordion__content {
  display: none;
}

.accordion__content--expanded {
  display: block;
}
